import { render } from "./AnalyticsComponentElementNew.vue?vue&type=template&id=fe315da8"
import script from "./AnalyticsComponentElementNew.vue?vue&type=script&lang=js"
export * from "./AnalyticsComponentElementNew.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__